<template>
  <div class="page password-reminder">
    <p class="page__logo">
      <img
        src="@/assets/images/logo@2x.png">
    </p>
    <div
      v-if="succeeded"
      class="page__form general-form pt-4 p-md-6"
      data-testid="reset-sent">
      <h1 class="h5 font-weight-bold text-center mb-4">
        再設定を受け付けました
      </h1>
      <div class="general-form__text">
        <!-- 登録の有無が分からないよう, 登録済み・未登録で同じ案内を出す -->
        <p>Todayに登録されているメールアドレスには、パスワードを再設定するためのメールが届きます。</p>
        <h2 class="h6 font-weight-bold mt-4">
          【メールが届かないとき】
        </h2>
        <p>入力したメールアドレスが、Todayに登録されているものと違う可能性があります。</p>
        <p class="font-weight-bold">
          登録したメールアドレスが分からない場合は、チームの指導者に確認してください。
        </p>
        <p>メールアドレスが正しい場合は、迷惑メールフォルダも確認してください。</p>
      </div>
      <div class="general-form__btn mt-5">
        <router-link
          to="/auth/login"
          class="btn btn-block btn-primary text-decoration-none">
          ログイン画面に戻る
        </router-link>
      </div>
    </div>
    <div
      v-else
      class="page__form general-form pt-4 p-md-6">
      <h1 class="h5 font-weight-bold text-center mb-4">
        パスワードを再設定
      </h1>
      <div class="general-form__text">
        <p>Todayに登録したメールアドレスを入力してください。</p>
        <p>そのメールアドレスに、パスワードを再設定するためのメールが届きます。</p>
        <p class="font-weight-bold">
          ※登録したメールアドレスが分からない場合は、チームの指導者に確認してください。
        </p>
      </div>
      <form>
        <validation-observer v-slot="{ invalid }">
          <div class="general-form__group form-group pb-4 mt-3 mt-md-4">
            <label
              for="email"
              class="col-form-label">登録メールアドレス</label>
            <validation-provider
              v-slot="v" 
              name="メールアドレス"
              rules="email|required">
              <b-form-input
                v-model="email"
                type="email"
                placeholder="sample@t-today.jp"
                data-testid="email-input" />
              <p
                class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
            <p class="mt-2 pb-3">
              <b-form-invalid-feedback
                v-for="message in nonFieldErrors"
                :key="message"
                :state="false">
                {{ message }}
              </b-form-invalid-feedback>
            </p>
          </div>
          <div class="general-form__btn mt-5">
            <button
              type="button"
              class="btn btn-block btn-primary"
              :disabled="invalid"
              @click="onClickReset">
              再設定メールを送信
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
import { load } from 'recaptcha-v3'
import { ATTEMPT_LIMIT_MESSAGE, isAttemptLimited } from '@/helper/attemptLimit'
export default {
  beforeRouteLeave(to, from, next) {
    if (this.recaptcha) {
      this.recaptcha.hideBadge()
    }
    next()
  },
  data() {
    return {
      email: '',
      recaptcha: null,
      recaptchaToken: null,
      nonFieldErrors: [],
      succeeded: false
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await this.loadRecaptcha().catch(() => {
      this.$store.commit('notify/set', {type: 'danger', message: '不明なエラーが発生しました。しばらく時間をあけてアクセスし直してください。なお、連続して発生する場合はログインページ下のアプリ更新を押してください。'})
      this.$router.push('/auth/login')
    })
    this.$store.commit('finishLoading')
  },
  methods: {
    async loadRecaptcha() {
      this.recaptcha = await load(process.env.VUE_APP_RECAPTCHA_SITE_KEY)
      this.recaptcha.showBadge()
    },
    async onClickReset() {
      this.$store.commit('startLoading')
      this.nonFieldErrors = []

      this.recaptchaToken = await this.recaptcha.execute('password_reset')
        .catch(() => {
          this.$store.commit('notify/set', {type: 'danger', message: '不明なエラーが発生しました。しばらく時間をあけてアクセスし直してください。なお、連続して発生する場合はログインページ下のアプリ更新を押してください。'})
          this.$router.push('/auth/login')
        })
      if (!this.recaptchaToken) {
        this.$store.commit('finishLoading')
        return
      }

      const postBody = {
        email: this.email, 
        recaptcha: this.recaptchaToken
      }
      this.$axios.post('/auth/password/reset/', postBody)
        .then(() => {
          this.succeeded = true
        }).catch(err => {
          // 試行回数の上限は, 時間をおけば再び送れるため, この画面に留めて表示する
          if (isAttemptLimited(err)) {
            this.nonFieldErrors = [ATTEMPT_LIMIT_MESSAGE]
            return
          }
          this.$store.commit('notify/set', {type: 'danger', message: '不明なエラーが発生しました。しばらく時間をあけてアクセスし直してください。なお、連続して発生する場合はログインページ下のアプリ更新を押してください。'})
          this.$router.push('/auth/login')
        }).finally(()=> {
          this.$store.commit('finishLoading')
        })
    }
  }
}
</script>

<style lang="sass" scoped></style>
